import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-base-datos-consulta',
  templateUrl: './base-datos-consulta.component.html',
  styleUrls: ['./base-datos-consulta.component.scss']
})
export class BaseDatosConsultaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
